import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import RubriqPlagiarismDocumentCardStatus from './RubriqPlagiarismDocumentCardStatus';
import RubriPlagiasimDocumentCardActions from './RubriqPlagiarismDocumentCardActions';
var RubriqPlagiarismDocumentCard = function RubriqPlagiarismDocumentCard(_ref) {
  var document = _ref.document,
    status = _ref.status;
  return /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column flex-md-row align-items-md-start gap-2 border p-3 "
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-grow-1 d-flex flex-column gap-1",
    style: {
      minWidth: '0'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center gap-2",
    style: {
      minWidth: '0'
    }
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-light fa-file-word"
  }), /*#__PURE__*/React.createElement("span", {
    className: "fw-semibold fs-5 text-truncate"
  }, document.fileName)), /*#__PURE__*/React.createElement("div", {
    className: "ms-2",
    style: {
      paddingLeft: '11.25px'
    }
  }, /*#__PURE__*/React.createElement(RubriqPlagiarismDocumentCardStatus, {
    document: document
  }))), /*#__PURE__*/React.createElement(RubriPlagiasimDocumentCardActions, {
    document: document,
    status: status
  }));
};
export default RubriqPlagiarismDocumentCard;